export const LOADED = "books/loaded"
export const ADD_BOOK = "books/addbook";
export const UPDATE_BOOK = "books/updatebook";
export const DELETE_BOOK = "books/deletebook"
export const EDIT_MODE = "books/editmode"